import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  AlertController,
  ModalController,
  NavParams,
  ToastController,
} from '@ionic/angular';
import { Stylist } from 'src/app/models';
import { StylistService } from 'src/app/services';
import { Utilities } from 'src/app/utilities/utilities';

// todo
// @IonicPage({
//   name: 'StylistChangePasswordFormPage',
//   segment: 'settings/stylist/password'
// })
// @Component({
//   templateUrl: 'stylist-change-password-form.page.html'
// })

@Component({
  selector: 'smr-stylist-change-password-form',
  templateUrl: './stylist-change-password-form.component.html',
  styleUrls: ['./stylist-change-password-form.component.scss'],
})
export class StylistChangePasswordFormComponent {
  public isLoading: boolean;

  public submitted: boolean;

  public errorMessage: string;

  public stylist: Stylist;

  public stylistChangePasswordForm: UntypedFormGroup;

  public currentPassword: UntypedFormControl;

  public newPassword1: UntypedFormControl;

  public newPassword2: UntypedFormControl;

  constructor(
    // todo
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private stylistService: StylistService,
    private formBuilder: UntypedFormBuilder
  ) {
    this.isLoading = false;
    this.submitted = false;
    this.stylist = this.navParams.get('stylist');
    this.currentPassword = new UntypedFormControl('', Validators.required);
    this.newPassword1 = new UntypedFormControl('', Validators.required);
    this.newPassword2 = new UntypedFormControl('', Validators.required);
    this.stylistChangePasswordForm = this.formBuilder.group({
      currentPassword: this.currentPassword,
      newPassword1: this.newPassword1,
      newPassword2: this.newPassword2,
    });
  }

  public onStylistChangePasswordFormSave() {
    this.submitted = true;
    this.errorMessage = '';

    if (this.stylistChangePasswordForm.valid === false) {
      return;
    }

    if (this.newPassword1.value !== this.newPassword2.value) {
      this.errorMessage = `New passwords don't match`;
      return;
    }

    this.isLoading = true;
    this.stylistService
      .changePassword(
        this.stylist,
        this.currentPassword.value,
        this.newPassword1.value
      )
      .subscribe({
        next: (stylist: Stylist) => {
          this.errorMessage = '';
          this.isLoading = false;
          this.toastCtrl
            .create({
              message: `Your password has been successfully changed.`,
              duration: 3000,
            })
            .then((toast) => toast.present())
            .then(() => this.modalCtrl.dismiss());
        },
        error: (error) => {
          this.isLoading = false;
          const parsedError = error.json();

          if (error.status === 400) {
            this.errorMessage = parsedError['err_msg'];
          } else {
            this.alertCtrl
              .create(Utilities.getDefaultErrorMessageConfig())
              .then((alert) => alert.present());
          }
        },
      });
  }

  public onDismiss() {
    this.modalCtrl.dismiss();
  }
}
